import { FirearmStorageLocationPLIServiceBase } from './firearm-storage-location-pli.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@scisys-uim/uim-common';

export interface StorageLocationDocumentInfo {
  filename: string;
  documentType: 'PLI';
  size: number;
  lastModified: string;
  documentUploadedBy?: string;
}

export interface StorageLocationDocumentUploadRestrictions {
  whitelistedExtensions: string[];
  whitelistedContentTypes: string[];
  blacklistedExtensions: string[];
  blacklistedContentTypes: string[];
}


@Injectable({
  providedIn: 'root'
})
export class FirearmStorageLocationPLIService extends FirearmStorageLocationPLIServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  listDocuments(id: number) {
    return this.http.get<StorageLocationDocumentInfo[]>(`${this.serviceBaseUrl}/${id}/documents`);
  }


  documentUploadRestrictions() {
    return this.http.get<StorageLocationDocumentUploadRestrictions>(`${this.serviceBaseUrl}/document-upload-restrictions`);
  }

  uploadDocument(id: number, file: File) {
    const data = new FormData();
    data.append('file', file);
    return this.http.post<StorageLocationDocumentInfo[]>(`${this.serviceBaseUrl}/${id}/documents`, data);
  }

  deleteDocument(id: number, filename: string) {
    return this.http.delete<StorageLocationDocumentInfo[]>(`${this.serviceBaseUrl}/${id}/documents`, { params: { filename } });
  }

  downloadDocument(id: number, filename: string) {
    return this.http.get(`${this.serviceBaseUrl}/${id}/documents/download`, { params: { filename }, responseType: 'blob' });
  }

}



